import React from 'react';
import { Result, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

export interface PasswordSuccessResultProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onButtonClick: () => void;
}

export const PasswordSuccessResult: React.FC<PasswordSuccessResultProps> = ({
  title = 'Password Set Up Successfully',
  subtitle = 'Your password has been set up successfully. You can now sign in to your account.',
  buttonText = 'Go to Sign In',
  onButtonClick,
}) => {
  return (
    <Result
      status="success"
      icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
      title={title}
      subTitle={subtitle}
      extra={
        <Button
          type="primary"
          onClick={onButtonClick}
          style={{
            backgroundColor: '#05796B',
            borderColor: '#05796B',
            height: '40px',
            fontSize: '16px',
            fontWeight: '600',
          }}
        >
          {buttonText}
        </Button>
      }
    />
  );
};
